export default {
    directionPill: {
        long: 'LONG',
        short: 'SHORT',
    },
}
